<template>
  <div class="progresser">
    <div class="progresser__bar">
      <div class="progresser__bar-item"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.progresser {
  width: 6rem;
  height: auto;

  &__bar {
    width: 6rem;
    height: 0.7rem;
    border-radius: 1rem;
    overflow: hidden;
    background-color: $white;

    &-item {
      width: 3rem;
      height: 0.7rem;
      margin: 0 0 0 -2rem;
      border-radius: 1rem;
      background-color: $intense-blue;
      animation: progresser 1.5s infinite cubic-bezier(0.76, 0, 0.24, 1);
    }
  }
}

@keyframes progresser {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(7rem);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
